import React, { PureComponent } from 'react';
import { Map, List, fromJS } from 'immutable';

import { injectIntl, defineMessages } from 'react-intl';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as common from 'libs/commonFunc';
import * as attachLib from 'libs/attachLib';
import * as attachActions from 'modules/templateAttach';
import * as currentStatusActions from 'modules/currentStatus';

import { ExamAttachList } from 'components';

let SEARCH_VALUE = '';
class CtExamAttachList extends PureComponent {
  constructor(props) {
    super(props);

    // 검색 기록 유지
    const { paramData } = this.props;
    const filterData = paramData.get('filter').toJS();
    let searchTypeData = 'searchAll';
    let searchTextData = '';
    if (Object.keys(filterData).length) {
      const searchOptions = ['searchAll', 'attachInfoNo', 'attachSubject', 'fileExt'];
      searchOptions.map(option => {
        if (filterData[option]) {
          searchTypeData = option;
          searchTextData = filterData[option];
        }
      });
    }

    this.state = {
      loading: false,
      fromNowView: false,
      actionImagePath: '',
      fitRowCount: 0,
      currentPage: 0,
      pageSize: 0,
      searchType: searchTypeData,
      searchText: searchTextData,
      tempFilter: {}
    };
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    this.handleInitFilter();
    this.setState({ pageSize: fitRowCount, fitRowCount });
  }

  componentDidUpdate(prevProps) {
    const { needReload, paramData } = this.props;

    if (
      needReload !== prevProps.needReload ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData
    ) {
      this.getAttach();
    }
  }

  onToggleModal = viewType => {
    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 실행결과 팝업창
  onToggleActionImageModal = data => {
    this.setState({ actionImagePath: data.image });

    this.onToggleModal(data.viewType);
  };

  getAttach = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { AttachActions, paramData } = this.props;
        const { currentPage, pageSize } = this.state;
        const params = {
          filter: JSON.stringify(paramData.get('filter')),
          sort: JSON.stringify(paramData.get('sort')),
          offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          limit: pageSize < 1 ? 20 : pageSize
        };

        await AttachActions.getAttach(params);
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  //구분 필터
  attachCategoryFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['attachCategoryArray'] === 'undefined') {
      filter['attachCategoryArray'] = [data.value];
    } else {
      const indexArray = filter['attachCategoryArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['attachCategoryArray'].push(data.value);
      } else {
        filter['attachCategoryArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['attachCategoryArray'].length === 0 && delete filter['attachCategoryArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  //훈련유형 필터
  attachExamTypeFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['attachExamTypeArray'] === 'undefined') {
      filter['attachExamTypeArray'] = [data.value];
    } else {
      const indexArray = filter['attachExamTypeArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['attachExamTypeArray'].push(data.value);
      } else {
        filter['attachExamTypeArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['attachExamTypeArray'].length === 0 && delete filter['attachExamTypeArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  //부가기능 필터
  attachFunctionFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['attachFunctionArray'] === 'undefined') {
      filter['attachFunctionArray'] = [data.value];
    } else {
      const indexArray = filter['attachFunctionArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['attachFunctionArray'].push(data.value);
      } else {
        filter['attachFunctionArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['attachFunctionArray'].length === 0 && delete filter['attachFunctionArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  //제약사항
  attachRestrictFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['attachRestrictArray'] === 'undefined') {
      filter['attachRestrictArray'] = [data.value];
    } else {
      const indexArray = filter['attachRestrictArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['attachRestrictArray'].push(data.value);
      } else {
        filter['attachRestrictArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['attachRestrictArray'].length === 0 && delete filter['attachRestrictArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  //삭제 여부
  isEnableFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['isEnableArray'] === 'undefined') {
      filter['isEnableArray'] = [data.value];
    } else {
      const indexArray = filter['isEnableArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['isEnableArray'].push(data.value);
      } else {
        filter['isEnableArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['isEnableArray'].length === 0 && delete filter['isEnableArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 필터 처리
  // 정렬 처리
  handleFetchData = ({ ...rest }) => {
    const { sorted } = rest;
    const sort = [];
    if (sorted && Array.isArray(sorted)) {
      // 정렬이 적용됨
      for (let i = 0; i < sorted.length; i++) {
        const data = sorted[i];
        sort.push({ field: data.id, order: data.desc ? 'DESC' : 'ASC' });
      }
    }

    const { AttachActions } = this.props;
    AttachActions.changeParam({
      name: 'sort',
      value: fromJS(sort)
    });
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색어 입력
  handleChangeSearch = e => {
    this.setState({ searchText: e.target.value });
  };

  // 검색
  handleOnSearch = e => {
    if (
      e.key === 'Enter' ||
      e.target.id === 'bt-search-input' ||
      e.target.parentNode.id === 'bt-search-input' ||
      e.target.parentNode.parentNode.id === 'bt-search-input'
    ) {
      const searchType = this.state.searchType;
      const searchValue = SEARCH_VALUE;

      const { AttachActions, paramData } = this.props;
      const filter = paramData.get('filter').toJS();

      if (searchValue !== filter[searchType]) {
        // 검색 타입 제거
        const searchOptions = ['searchAll', 'attachInfoNo', 'attachSubject', 'fileExt'];
        searchOptions.map(option => delete filter[option]);

        if (searchValue !== '') {
          filter[searchType] = searchValue;
        }

        this.setState({ currentPage: 0 });
        AttachActions.changeParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  //체크 취소
  cancleCheck = () => {
    const { AttachActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter
    });
  };

  // // 개별 필터
  // handleChangeFilter = (column, value, isMulti) => {
  //   const { AttachActions, paramData } = this.props;
  //   const filter = paramData.get('filter').toJS();

  //   // 멀티 선택 필터
  //   if (isMulti) {
  //     if (typeof filter[column] === 'undefined') {
  //       filter[column] = value;
  //     } else if (Number(filter[column]) === Number(value)) {
  //       delete filter[column];
  //     } else {
  //       if (Number(value) & Number(filter[column])) {
  //         filter[column] = Number(filter[column]) - Number(value);
  //       } else {
  //         filter[column] = Number(filter[column]) + Number(value);
  //       }
  //     }
  //     // 단일 선택 필터
  //   } else {
  //     if (filter[column] === value) {
  //       delete filter[column];
  //     } else {
  //       filter[column] = value;
  //     }
  //   }

  //   this.setState({ currentPage: 0 });
  //   AttachActions.changeParam({
  //     name: 'filter',
  //     value: fromJS(filter)
  //   });
  // };

  // 날짜 필터
  handleChangeDateFilter = (type, data) => {
    const { AttachActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    if (data.startDate) {
      filter['start' + type] = data.startDate;
    }
    if (data.endDate) {
      filter['end' + type] = data.endDate;
    }

    this.setState({ currentPage: 0 });
    AttachActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 필터 초기화
  handleInitFilter = () => {
    const { AttachActions } = this.props;

    AttachActions.changeParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }

    this.setState({ searchType: 'searchAll', searchText: '', tempFilter: {} });
  };

  // 페이지 이동 처리
  handlePagination = pageNo => {
    this.setState({ currentPage: pageNo });
  };

  // 페이지 개수 처리 (페이지 초기화)
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter,
      isLoading: false
    });
  };

  //체크한 필터 실행
  executeFilter = () => {
    const { AttachActions } = this.props;
    const { tempFilter } = this.state;
    const filter = tempFilter;

    this.setState({ currentPage: 0 });
    AttachActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { loading, fromNowView, currentPage, pageSize, fitRowCount, searchType, searchText, tempFilter } = this.state;
    const { isAuth, isModal, templateData, totalPages, totalCount, paramData } = this.props;
    const { handleFetchData, onToggleModal, onToggleActionImageModal, takeSearchValue } = this;
    // 검색
    const {
      handleSearchOptions,
      handleChangeSearch,
      handleOnSearch,
      handleChangeDateFilter,
      handleInitFilter,
      searchTextRef,
      cancleCheck,
      filterClose,
      executeFilter,
      attachCategoryFilter,
      attachExamTypeFilter,
      attachFunctionFilter,
      attachRestrictFilter,
      isEnableFilter
    } = this;

    // 페이징
    const { handlePagination, handlePageSizeOnChange } = this;

    const filterData = paramData.get('filter').toJS();

    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = [];
    pageSizeArray.map(value => {
      pageSizeOptions.push({ text: value, value: value });
    });

    const searchOptions = [
      { key: 0, text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })), value: 'searchAll' },
      { key: 1, text: 'No', value: 'attachInfoNo' },
      {
        key: 2,
        text: defineMessages(formatMessage({ id: 'ExamAttachList_1', defaultMessage: '제목' })),
        value: 'attachSubject'
      },
      {
        key: 3,
        text: defineMessages(formatMessage({ id: 'ExamAttachList_4', defaultMessage: '확장자' })),
        value: 'fileExt'
      }
    ];

    return (
      <ExamAttachList
        isAuth={isAuth}
        isModal={isModal}
        fromNowView={fromNowView}
        manual
        data={templateData && Map.isMap(templateData) ? templateData.toJS().success : {}}
        totalCount={totalCount}
        page={currentPage}
        pages={totalPages}
        pageSize={pageSize}
        defaultPageSize={fitRowCount}
        pageSizeOptions={pageSizeOptions}
        loading={loading}
        actionImagePath={this.state.actionImagePath}
        onFetchData={handleFetchData}
        onToggleModal={onToggleModal}
        onToggleActionImageModal={onToggleActionImageModal}
        // 검색 영역
        searchObj={{
          filterData: filterData,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: totalCount,
          searchType: searchType,
          searchText: searchText,
          searchOptions: searchOptions,
          handleSearchOptions: handleSearchOptions,
          handleChangeSearch: handleChangeSearch,
          handleOnSearch: handleOnSearch,
          handleInitFilter: handleInitFilter,
          defaultPageSize: fitRowCount,
          pageSizeOptions: pageSizeOptions,
          handlePageSizeOnChange: handlePageSizeOnChange,
          takeSearchValue: takeSearchValue,
          searchTextRef: searchTextRef,
          paramData: paramData,
          tempFilter: tempFilter
        }}
        // 필터
        attachCategoryFilter={attachCategoryFilter}
        attachExamTypeFilter={attachExamTypeFilter}
        attachFunctionFilter={attachFunctionFilter}
        attachRestrictFilter={attachRestrictFilter}
        isEnableFilter={isEnableFilter}
        cancleCheck={cancleCheck}
        filterClose={filterClose}
        executeFilter={executeFilter}
        // handleChangeFilter={handleChangeFilter}
        handleChangeDateFilter={handleChangeDateFilter}
        // 페이징 처리
        handlePagination={handlePagination}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    isModal: state.currentStatus.get('isModal'),
    templateData: state.templateAttach.get('data'),
    needReload: state.templateAttach.get('needReload'),
    totalPages: state.templateAttach.get('totalPages'),
    totalCount: state.templateAttach.get('totalCount'),
    paramData: state.templateAttach.get('param'),
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  AttachActions: bindActionCreators(attachActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamAttachList));



// WEBPACK FOOTER //
// ./src/script/containers/examAttach/CtExamAttachList.js